<template>
    <div
        class="w-full rounded-lg flex flex-col justify-center items-center p-8 mt-6"
    >
        <HeaderIcon>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#5F6D7E" style="opacity:1;"><path  d="M6 5a1 1 0 1 0 0 2a1 1 0 0 0 0-2M3 6a3 3 0 1 1 4 2.83V9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-.17a3.001 3.001 0 1 1 2 0V9a4 4 0 0 1-4 4h-2v2.17a3.001 3.001 0 1 1-2 0V13H9a4 4 0 0 1-4-4v-.17A3 3 0 0 1 3 6m15-1a1 1 0 1 0 0 2a1 1 0 0 0 0-2m-6 12a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/></svg>
        </HeaderIcon>

        <div class="w-full max-w-sm mt-8 z-50">
            <div class="flex flex-col items-center justify-center">
                <div class="text-2xl text-center font-medium text-primary-font">
                    {{headingText}}
                </div>
                <div class="text-sm text-center text-primary-gray">
                    {{subText}}
                </div>
            </div>
            <div class="flex flex-col gap-4 mt-6 mb-3 z-50">
                <div
                    :class="[
                        'flex items-start gap-3 p-4 border rounded-lg cursor-pointer transition bg-white',
                        signupPath === 'join'
                            ? 'border-primary-green'
                            : 'border-primary-border',
                    ]"
                    @click="signupPath === 'join' ? selectSignupPath(null) : selectSignupPath('join')"
                >
                    <input
                        type="checkbox"
                        class="mt-2 w-3 h-3 text-green-600 accent-green-600 cursor-pointer"
                        :checked="signupPath === 'join'"
                        @click.stop="signupPath === 'join' ? selectSignupPath(null) : selectSignupPath('join')"
                    />
                    <div>
                        <h3 class="text-lg font-medium text-primary-font">
                            Join an existing market
                        </h3>
                        <p class="text-sm text-secondary-text">
                            Search and join Market already on the platform
                        </p>
                    </div>
                </div>

                <div
                    :class="[
                        'flex items-start gap-3 p-4 border rounded-lg cursor-pointer transition bg-white',
                        signupPath === 'create'
                            ? 'border-primary-green'
                            : 'border-primary-border',
                    ]"
                    @click="signupPath === 'create' ? selectSignupPath(null) : selectSignupPath('create')"
                >
                    <!-- Checkbox on the left -->
                    <input
                        type="checkbox"
                        class="mt-3 w-3 h-3 text-green-600 accent-green-600 cursor-pointer"
                        :checked="signupPath === 'create'"
                        @click.stop="signupPath === 'create' ? selectSignupPath(null) : selectSignupPath('create')"
                    />
                    <div>
                        <h3 class="text-base font-medium text-primary-font">
                            Create a New Market
                        </h3>
                        <p class="text-sm text-secondary-text">
                            Start from scratch and create your own market
                        </p>
                    </div>
                </div>
                <p v-if="validationErrors.market_option" class="text-red-500 text-sm">
                    {{ validationErrors.market_option }}
                </p>
            </div>

            <button
                @click="syncSignupPath"
                :disabled="isLoading"
                type="submit"
                class="w-full py-2 px-4 bg-primary-green text-white font-medium rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-primary-green"
            >
                <span v-if="isLoading">Processing...</span>
                <span v-else>Next</span>
            </button>
        </div>
    </div>
</template>

<script setup>
import { watch } from "vue";
import { useSignupWizardStore } from "@/store";
import { storeToRefs } from "pinia";
import HeaderIcon from "./components/HeaderIcon.vue";

const signupWizardStore = useSignupWizardStore();

const {isLoading, formData, signupPath, validationErrors} = storeToRefs(signupWizardStore)
const {selectSignupPath, validateForm, syncSignupPath} = signupWizardStore

const headingText = "Welcome to Amana Market";
const subText = "How would you like to start up and get started";

// watch(formData, validateForm, { deep: true });
</script>
